export default "__VITE_ASSET__BkcbLR_N__"